// extracted by mini-css-extract-plugin
module.exports = {"root":"MobileHeader_root__vNNQY","title":"MobileHeader_title__2Ozu_","titleText":"MobileHeader_titleText__TaCMV","icon":"MobileHeader_icon__26Aa9"};